// extracted by mini-css-extract-plugin
export default {"processModalButton":"TenantFeatureSettingsCheckbox_processModalButton__ty63D"};